import React from "react";

import { useTranslation } from "react-i18next";

import classNames from "classnames";

export function GroupedPlayerStatsHeader(props: {
	isExpanded?: boolean;
	onSetExpand: (newValue: boolean) => void;
	title: string;
}) {
	const { t } = useTranslation();

	const headClass = classNames(
		"offer__head offer__head--secondary offer--additional__head",
		{
			"is-collapsed": !props.isExpanded,
			"is-expanded": props.isExpanded,
		}
	);

	const iconClass = classNames("offer__toggle__icon u-icon u-icon--tny", {
		"u-icon--caret--down": props.isExpanded,
		"u-icon--caret--right": !props.isExpanded,
	});

	const toggleClasses = classNames("offer__head__data offer__toggle", {
		"offer__toggle--sml": false,
	});

	return (
		<div className={headClass}>
			<div className="offer__head__row offer--additional__head__row">
				<div
					className="offer__head__data offer__title"
					title={t(props.title)}
				>
					<div className="offer__title__wrapper">
						<span className="offer__name offer--additional__group">
							{t(props.title)}
						</span>
					</div>
				</div>
				<div className={toggleClasses}>
					<button
						className="offer__toggle__btn btn btn--square btn--square--xsml btn--ghost"
						type="button"
						onClick={() => props.onSetExpand(!props.isExpanded)}
					>
						<i className={iconClass} />
					</button>
				</div>
			</div>
		</div>
	);
}
